import type { SliderBaseProps } from 'antd/lib/slider';
import Slider from 'antd/lib/slider';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledSlider: StyledComponent<typeof Slider, SliderBaseProps> = styled(Slider)`
  .ant-slider-rail {
    background-color: #2d4a6c;
  }
`;
